/*
 * @Mixin: 动态插入弹幕
 * @Params 
 * data: @type: Array  eg: [{ imgSrc: '图片地址', text: '文字内容' }]
 * time: @type: Number 默认5秒 eg: 5000  时间间隔不建议设置过快
 */

// interface danmuDataItem {
// 	imgSrc: string,
// 	text: string 
// }

export default {
	beforeDestroy() { 
		// this.$danmu.closeAll()
	},
	methods: {
		initDanmu(data, time = 5000) {
			if(!data && data.length === 0) return false;
			let imgs = data;
			let index = 0

			this.$danmu.open({
				imgSrc: imgs[index].imgSrc,
				message: imgs[index].text,
			})
			setInterval(() => {
				if (index !== imgs.length - 1) {
					index += 1
				} else {
					index = 0
				}
				this.$danmu.open({
					imgSrc: imgs[index].imgSrc,
					message: imgs[index].text,
				})
			}, time)
		},
	},
}
